import React, { FC, useEffect, useState } from 'react'
import { RequestFormProps, RequestInputs } from '@utils/request'
import requestForm from '@components/requestForms/request.form'
import Notification from '@components/ui/notification'
import RadioInput from '@components/requestForms/inputs/radio.input'

const meetingQuestionName = 'technicianMeeting'

const ProfessionalAdvisoryServiceInformationForm: FC<RequestFormProps> = ({
	inputs,
	errors,
	onInputsChange,
	onFixError,
	setDisabled
}) => {
	const {
		pageAssets,
		radioSelectionYesNo,
		radioSelectionYesNoDoNotKnow,
		UpdateRequestInputsErrorsArray
	} = requestForm()

	const [eligibilityAnswer, setEligibilityAnswer] = useState('')
	const [meetingInput, setMeetingInput] = useState<RequestInputs>({
		name: meetingQuestionName,
		value: '',
		label:
			pageAssets?.request_form_professionalAdvisoryServiceInformation_technician_meeting_question,
		labelKey:
			'request_form_professionalAdvisoryServiceInformation_technician_meeting_question',
		required: true,
		isSentInDetails: true
	})

	const eligibilityQuestion = {
		name: 'eligibility',
		label:
			pageAssets?.request_form_professionalAdvisoryServiceInformation_eligibility_question
	}
	const eligibilityCriteria =
		pageAssets?.request_form_professionalAdvisoryServiceInformation_eligibility_criteria
	const notEligibleMessage =
		pageAssets?.request_form_professionalAdvisoryServiceInformation_not_eligible
	const meetingYesMessage =
		pageAssets?.request_form_professionalAdvisoryServiceInformation_technician_meeting_yes
	const projectDocumentsMessage =
		pageAssets?.request_form_professionalAdvisoryServiceInformation_project_documents

	useEffect(() => {
		setDisabled(true)
	}, [setDisabled])

	const onChangeEligibility = (value: string) => {
		const isEligible = value === radioSelectionYesNo[0].value
		setEligibilityAnswer(value)
		setDisabled(!isEligible)
		const resetMeetingInput = {
			...meetingInput,
			value: '',
			valueKey: ''
		}
		setMeetingInput(resetMeetingInput)

		if (!isEligible) {
			onInputsChange(
				inputs.filter((input) => input.name !== meetingQuestionName)
			)
			onFixError(UpdateRequestInputsErrorsArray(errors, meetingQuestionName))
			return
		}

		onInputsChange([
			...inputs.filter((input) => input.name !== meetingQuestionName),
			resetMeetingInput
		])
	}

	const onChangeMeeting = (value: string, valueKey: string) => {
		const updatedMeetingInput = {
			...meetingInput,
			value,
			valueKey
		}
		setMeetingInput(updatedMeetingInput)
		onInputsChange([
			...inputs.filter((input) => input.name !== meetingQuestionName),
			updatedMeetingInput
		])
		onFixError(UpdateRequestInputsErrorsArray(errors, meetingQuestionName))
	}

	return (
		<>
			<Notification type="info" text={eligibilityCriteria || ''} hasHtml />
			<RadioInput
				name={eligibilityQuestion.name}
				label={eligibilityQuestion.label}
				value={eligibilityAnswer}
				list={radioSelectionYesNo}
				onChange={onChangeEligibility}
			/>

			{eligibilityAnswer === radioSelectionYesNo[1].value && (
				<Notification type="error" text={notEligibleMessage || ''} hasHtml />
			)}

			{eligibilityAnswer === radioSelectionYesNo[0].value && (
				<>
					<RadioInput
						name={meetingInput.name}
						label={meetingInput.label}
						value={meetingInput.value}
						list={radioSelectionYesNoDoNotKnow}
						required={meetingInput.required}
						hasError={errors.includes(meetingInput.name)}
						onChange={onChangeMeeting}
					/>
					{meetingInput.value === radioSelectionYesNoDoNotKnow[0].value && (
						<Notification type="info" text={meetingYesMessage || ''} hasHtml />
					)}
					<Notification
						type="info"
						text={projectDocumentsMessage || ''}
						hasHtml
					/>
				</>
			)}
		</>
	)
}

export default ProfessionalAdvisoryServiceInformationForm
